import React from "react";
import AwarenessProgramsSection from "../../Sections/AwarenessProgramsSection/Content";
const AwarenessProgramPage = () => {
  return <AwarenessProgramsSection />;
};

export default AwarenessProgramPage;
